import { SearchBox } from "@/features/common/components/filter/SearchBox";
import { ModelNumericFilter } from "@/features/model/components/modeList/filter/ModelNumericFilter";
import { ModelPrefJobTypeFilter } from "@/features/model/components/modeList/filter/ModelPrefJobTypeFilter";

const heightFilterList = [
  { label: "150cm以下", value: { lt: 150 } },
  { label: "150-160cm", value: { lte: 160, gte: 150 } },
  { label: "161-170cm", value: { lte: 170, gt: 160 } },
  { label: "171-180cm", value: { lte: 180, gt: 170 } },
  { label: "180cm以上", value: { gt: 180 } },
];

const weightFilterList = [
  { label: "40kg以下", value: { lt: 40 } },
  { label: "40-50kg", value: { lte: 50, gte: 40 } },
  { label: "51-60kg", value: { lte: 60, gt: 50 } },
  { label: "61-70kg", value: { lte: 70, gt: 60 } },
  { label: "70kg以上", value: { gt: 70 } },
];

export const modelListFilterList = [
  {
    title: "名稱",
    component: <SearchBox label="KOL名稱" name="username" variant="light" />,
    displayToSubscriber: true,
  },
  {
    title: "適合類型",
    component: <ModelPrefJobTypeFilter />,
    displayToSubscriber: true,
  },
  {
    title: "身高",
    component: (
      <ModelNumericFilter filterList={heightFilterList} name="height" />
    ),
    displayToSubscriber: true,
  },
  {
    title: "體重",
    component: (
      <ModelNumericFilter filterList={weightFilterList} name="weight" />
    ),
    displayToSubscriber: true,
  },
];
